export const getEmailFromSearchParam = (emailSearchParam: string) => {
  try {
    return window.atob(emailSearchParam);
  } catch {
    return '';
  }
};
